<div class="subBlockContainer" style="width: unset">
    <div id="addAMPProduct" class="blockContainer subBlockContainer_toplevel" style="width: 983px !important; overflow-x: hidden;" >
        <div class="combination-loader extendwidth combinedLoader">

            <div class="child-sidebar">
                <child-header [title]="productCategory + ' Family'" (closeEvent)="closeFamilyPanel()"></child-header>

                <div class="child-body child-body-narrowMode">
                    <div class="searchInputGroup">
                        <div class="searchIcon search-carts">
                            <img src="../images/new_ui/filter.png">
                        </div>
                        <input class="searchInput searchInputGroup-small" type="text" placeholder="Filter"
                            onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="famliySearchField"
                            (ngModelChange)="onFamilySearchChange()">
                    </div>
                    <ng-container *ngFor="let item of familyListFiltered">
                        <div
                            [class.active]="isActive(item)"
                            class="menu-wrapper menu-wrapper-position"
                            (click)="selectFamily(item)"
                        >
                            <label class="small-title">{{item}}</label>
                        </div>
                    </ng-container>
                    <mat-spinner
                        *ngIf="loadingFamilyList"
                        mode="indeterminate"
                        class="circle cSPCustomerEntitlements-loading"
                        diameter="20" style="position: relative; top:15px; margin: auto;">
                    </mat-spinner>
                </div>
            </div>

            <div class="child-loader">
                <div id="addressContainer">
                    <div id="shippingAddress" class="subBlockContainer">
                        <div class="subBlockContent">
                            <child-header title="Products" (closeEvent)="close()"></child-header>
                            <div class="child-body">
                                <div *ngIf="!isLoadingContent" class="inner-subBlock-wrapper">
                                    <div class="row filter-wrapper">
                                        <div class="searchInputGroup" style="width: auto;margin-left:10px;">
                                            <div class="searchIcon">
                                                <img src="../images/new_ui/filter.png">
                                            </div>
                                            <input class="searchInput" type="text" #searchValue placeholder="Filter" [(ngModel)]="searchSubscriotion" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" (ngModelChange)="filterSubscriptionItems()">
                                        </div>
                    
                                        <!-- # brand filter -->
                                        <div class="listpart col-md-6" style="margin-right: 10px;">
                                        </div>
                                    </div>
                                    <ng-container>
                
                                        <div class="col-md-12 align-center" *ngIf="!subscriptionItemsFilter?.length && !isLoadingContent">
                                            <label class="noData-label">
                                                No items found
                                            </label>
                                        </div>
            
                                        <div  *ngIf="subscriptionItemsFilter?.length && !isLoadingContent">
                                            <div class="mTable">
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col" class="align-left" style="width: 60%">DESCRIPTION</th>
                                                            <!-- <th scope="col" class="align-right" style="width: 20%; text-align: right;">BUY PRICE</th> -->
                                                            <th scope="col" class="align-center" style="width: 20%">QTY</th>
                                                            <th scope="col" class="align-center" style="width: 20%"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let annuityItem of subscriptionItemsFilter">
                                                            <td>
                                                                <span  class="description-popup">{{annuityItem?.description}}</span>                                                                                                                                          
                                                                <!-- <div class="result-info">
                                                                    <div class="produc-secondary-title-wrapper">
                                                                        <span class="light-text">STOCK CODE:&nbsp;</span>
                                                                        <span >{{annuityItem?.stockCode}}</span>
                                                                    </div>
                                                                </div> -->
                                                            </td>                             
                                                            <td class="align-center" style="position: relative;vertical-align: middle;">
                                                                <input class="align-center input-wrapper input-wrapper-small" [(ngModel)]="annuityItem.quantity" (keypress)="_keyPress($event)" type="text" (blur)="changeQty(annuityItem)">
                                                                <mat-icon matSuffix class="editmpnidicon align-top" *ngIf="annuityItem?.minMaxQtyText" placement="bottom" ngbTooltip="{{annuityItem?.minMaxQtyText}}">info</mat-icon>
                                                            </td>
                                                            <td class="align-center" style="vertical-align: middle;">
                                                                <button id="{{annuityItem?.stockCode}}" class="button button-red button-mid confirmbutton" *ngIf="!annuityItem?.isExisting" (click)="addSubscriptionItem(annuityItem)">Add</button>
                                                                <button id="{{annuityItem?.stockCode}}" class="button button-red button-mid confirmbutton" *ngIf="annuityItem?.isExisting" (click)="addSubscriptionItem(annuityItem)">Update</button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <ng-container *ngIf="showSideBar">
        <div class="subBlockContent" id="addAMPProductSideBar">
            <child-header [title]="'Cart'" (closeEvent)="closeSideBar()"></child-header>
            <div class="child-body">
                <div class="inner-subBlock-wrapper">
                    <ng-container>
                        <div>
                            <div class="searchInputGroup" style="width: 186px;margin:auto;margin-bottom: 15px;">
                                <div class="searchIcon search-carts">
                                    <img src="../images/new_ui/filter.png">
                                </div>
                                <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                                    onblur="this.placeholder='Filter'" [(ngModel)]="sideBarSubscriptionSearch">
                            </div>
                            <ng-container *ngFor="let item of AMPsubsItemsPendingList;index as i">
                                <ng-container
                                    *ngIf="item.description.toLowerCase().includes(sideBarSubscriptionSearch.toLowerCase())">
                                    <div class="menu-wrapper row menu-wrapper-position">
                                        <div class="total-div pr-2" style="width: 90%;">
                                            <div class="narrow-title">{{item.preivewDescription ? item?.preivewDescription : item?.description }}</div>
                                            <span class="narrow-text">
                                                <span style="font-weight: bold;">
                                                    Qty:
                                                </span>
                                                <input
                                                    type="text"
                                                    class="align-center input-wrapper input-wrapper-small"
                                                    [disabled]="loadingPreview"
                                                    (change)="quantityChange()"
                                                    [(ngModel)]="item.quantity"
                                                >
                                            </span>
                                            <span class="narrow-text">
                                                &nbsp;&nbsp;
                                                <span style="font-weight: bold;">Unit Price:</span>
                                                {{ item?.previewPrice ?  item?.previewPrice : item?.itemPrice }}
                                            </span>
                                        </div>
                                        <div >
                                            <span class="basic-icon delete-icon information-icon-position"
                                                (click)="removeSubscriptionPendingItem(i)"></span>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <div class="align-center mt-3">
                                <button class="button button-red button-mid btn-csp"
                                    [disabled]="AMPsubsItemsPendingList.length==0 || loadingPreview"
                                    (click)="confirmProduct()">Checkout</button>
                            </div>
                            <loading-screen *ngIf="loadingPreview" [isScrolled]="true"></loading-screen>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>
    <router-outlet></router-outlet>
</div>
